import { defineStore } from "pinia";
import { USER_TYPE, USER_POSITION } from '/constants/common.js'

export const useAuthStore = defineStore("auth", () => {
  const baseStore = useBaseStore();
  const userStore = useUserStore();
  const user = ref({});
  const isAuthenticated = ref(false);

  const login = async ({ user_id, pwd, rememberMe, force }) => {
    const data = {
      email: user_id,
      pwd,
      srcloc: "W", // depend on
      rememberMe,
      force,
    };
    const result = await usePost("/admin/login", data);

    if (result) {
      const userData = await baseStore.getUserMe();
      user.value = userData;
      userData.userType = baseStore.adminMode ? USER_TYPE.ADMIN : userData.userType
      await userStore.$patch({ type: userData.userType, position: userData.userRole })
      return userData;
    }
    return result;
  };
  
  const logout = () => {
    // resetCodes(commit); TODO reset code search
    return usePost(baseStore.adminMode ? "/admin/logout" :"/logout", { deleteMe: true });
  };

  return {
    user,
    isAuthenticated,
    login,
    logout,
  };
});
